exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-content-my[data-v-150a9aa0]{\n    position: relative;\n    margin: 10% auto;\n    padding: 30px;\n    max-width: 65vw;\n    border-radius: 4px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.16);\n    background-color: #FAFAFA;\n}\n.modal-2[data-v-150a9aa0]{\n    z-index: 5;\n    position: fixed;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    overflow: auto;\n    transition: all 0.5s ease;\n    background-color: rgba(128, 128, 128, 0.418);\n}\n.btn-edit[data-v-150a9aa0]{\n    background-color: #3490dc;\n    color: #fff;\n}\n", ""]);

// exports
